import React, { ReactNode } from 'react'
import { ConfigProvider } from 'antd'
import localePl from 'antd/es/locale/pl_PL'
import localeEn from 'antd/es/locale/en_US'
import updateLocale from 'dayjs/plugin/updateLocale'
import dayjs from 'dayjs'
import 'dayjs/locale/pl'
import 'dayjs/locale/en'

type Props = {
  locale: string
  children: ReactNode
}

dayjs.extend(updateLocale)
dayjs.updateLocale('pl', {
  weekStart: 1,
})
dayjs.updateLocale('en', {
  weekStart: 1,
})

const AntdProvider: React.FC<Props> = ({ children, locale }) => {
  return (
    <ConfigProvider locale={locale == 'pl' ? localePl : localeEn}>
      {children}
    </ConfigProvider>
  )
}

export default AntdProvider
